import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Badge from 'components/field/Badge';
import Alert from 'components/global/Alert';
import Authorization from 'components/global/Authorization';
import Icon from 'components/global/Icon';
import Skeleton from 'components/global/Skeleton';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';
import { FilterAction, FilterType } from 'components/list/DynamicListFilterUtils';

import useFetchAndParseOnView from 'hooks/useFetchAndParseOnView';

import { BRANCHES } from 'services/consts';

import PATHS from 'utils/paths';

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

import { SectionWrapper } from '../OnboardingV2/Onboarding.styled';
import * as S from './ShipmentsNeedAction.styled';

const MissingInformationCard = () => {
	const { t } = useTranslation();
	const [numberOfMissingBranch, setNumberOfMissingBranch] = useState(0);
	const [missingBranchErrors, setMissingBranchErrors] = useState([]);
	const navigate = useNavigate();

	const {
		ref,
		data: data,
		loading
	} = useFetchAndParseOnView({
		url: BRANCHES.GET_MISSING_BRANCH_INFORMATION
	});

	useEffect(() => {
		if (data) {
			setNumberOfMissingBranch(data.count);
			setMissingBranchErrors(data.branchCodes.split(','));
		}
	}, [data]);

	return (
		<Authorization path="/home/missingInformationCard">
			<SectionWrapper ref={ref}>
				<S.SectionHeader>
					<Typography variant="p2" fontWeight="700">
						missingInformationCardTitle
					</Typography>
					<Tooltip placement="right" title={t('missingInformationCardTooltip')}>
						<Icon icon={faCircleInfo} />
					</Tooltip>
					{!loading && numberOfMissingBranch > 0 && (
						<Badge variant="pill" size="small" color="red" text={numberOfMissingBranch} />
					)}
				</S.SectionHeader>

				{loading && (
					<S.ContentWrapper>
						<Skeleton variant="text" width="100%" height="5rem" />
						<Skeleton variant="text" width="100%" height="5rem" />
					</S.ContentWrapper>
				)}

				<S.CardContainer>
					{missingBranchErrors.length > 0 &&
						missingBranchErrors.map((errorCode, index) => {
							return (
								<Alert
									key={index}
									variant="warning"
									showIcon
									header={'missingInformationAlertTitle'}
									content={`error.${errorCode}`}
									ctaButtonLabel="manageBranches"
									onCtaButtonClick={() =>
										navigate(PATHS.BRANCHES, {
											state: {
												defaultFilters: [
													{
														column: {
															Header: 'status',
															accessor: 'status',
															filterType: FilterType.enumMulti
														},
														action: FilterAction.is,
														value: ['missingInformation']
													}
												]
											}
										})
									}
								/>
							);
						})}
				</S.CardContainer>
			</SectionWrapper>
		</Authorization>
	);
};

export default MissingInformationCard;
